import OnlyTitle from "./onlytitle"
import TopTitleBottomImage from "./toptitlebottomimage"
import LeftTitleRightImage from "./lefttitlerightimage"
import OneTitleThreeImage from "./onetitlethreeimage"
import TopTitleThreeImage from "./toptitlethreeimage"

export default {
    OnlyTitle,
    TopTitleBottomImage,
    OneTitleThreeImage,
    LeftTitleRightImage,
    TopTitleThreeImage,
}